// extracted by mini-css-extract-plugin
module.exports = {"Banner":"style_Banner__3FUCm"};